import { FieldErrors, FieldValues } from 'react-hook-form';

const initialGenerator = (value: string) => {
  if (value) {
    let initial: any = value.split(' ');
    if (initial[1]) {
      return initial[0][0].toUpperCase() + initial[1][0].toUpperCase();
    } else {
      return initial[0][0].toUpperCase();
    }
  } else {
    return '';
  }
};

// Joins all react-hook-form field error messages into one string, so a single
// toast can surface every validation failure (not just the first/inline one).
const getFormErrorMessages = <T extends FieldValues>(errors: FieldErrors<T>): string =>
  Object.values(errors)
    .map((error) => error?.message)
    .filter((message): message is string => Boolean(message))
    .join('\n');

// Shared by ConfigLayoutDashboards.tsx (gates the Save button) and Info.tsx
// (shows the inline warning) so the "at limit" definition can't drift between
// the two copies — `value` guarded since it may briefly be undefined before
// react-hook-form's defaultValues resolve.
const isAtCharLimit = (value: string | undefined, max: number): boolean =>
  (value || '').length >= max;

export { initialGenerator, getFormErrorMessages, isAtCharLimit };
